import { cloneDeep } from 'lodash';
import { tutorialCompletion } from 'states/persistInStorage';
import { BundledTutorials, Tutorial, TutorialCompletion } from 'types/states';
import { isWeb } from './deviceUtils';
import { useUiStore } from 'stores/uiStore';

export const defaultCompletion: TutorialCompletion = {
  firstTimer: { status: 'NOT_COMPLETED' },
  automaticVehicleSelection: { status: 'NOT_COMPLETED' },
};

export const openTutorial = (tutorial: Tutorial) => {
  const tutorialStatus = tutorialCompletion() ?? defaultCompletion;
  if (tutorialStatus[tutorial]?.status) {
    tutorialStatus[tutorial].status = 'OPEN';
  } else {
    tutorialStatus[tutorial] = { status: 'OPEN' };
  }
  tutorialCompletion(cloneDeep(tutorialStatus));
  isWeb && openTutorialModal(tutorial);
};

export const completeTutorial = (tutorial: keyof TutorialCompletion) => {
  const tutorialStatus = tutorialCompletion() ?? defaultCompletion;
  if (tutorialStatus[tutorial]?.status) {
    tutorialStatus[tutorial].status = 'COMPLETED';
  } else {
    tutorialStatus[tutorial] = { status: 'COMPLETED' };
  }
  tutorialCompletion(cloneDeep(tutorialStatus));
};

export const getTutorials = () => {
  return Object.keys(tutorialCompletion()).map((key) => key as Tutorial);
};

export const isBundledTutorial = (
  key: Tutorial
): key is keyof BundledTutorials => {
  const keys: (keyof BundledTutorials)[] = [
    'firstTimer',
    'automaticVehicleSelection',
  ];
  return keys.some((k) => k === key);
};

export const openTutorialModal = (tutorial: Tutorial) => {
  useUiStore
    .getState()
    .setSheetModal(isBundledTutorial(tutorial) ? tutorial : 'remoteTutorial');
};
